import {
  POINT_ICON_SIZE,
  POINT_ICON_OFFSET,
  PIN_BG_PATH,
  PIN_INNER_CIRCLE_PATH,
  LAWYER_FIGURE_PATH,
  ORG_FIGURE_PATH,
} from './mapConstants';
import type {
  YMaps,
  LawyerPinType,
  YMapsLayoutClass,
  YMapsLayoutInstance,
  YMapsShape,
} from './types';

const FIGURE_PATH: Record<LawyerPinType, string> = {
  lawyer: LAWYER_FIGURE_PATH,
  organization: ORG_FIGURE_PATH,
};

const buildPinSvg = (figurePath: string): string =>
  `<svg class="map-point__svg" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g class="map-point__shape">
      <path class="map-point__inner-circle" d="${PIN_INNER_CIRCLE_PATH}" />
      <path class="map-point__bg" d="${PIN_BG_PATH}" />
      <path class="map-point__figure" d="${figurePath}" />
    </g>
  </svg>`;

export const createPinLayout = (ymaps: YMaps, type: LawyerPinType): YMapsLayoutClass =>
  ymaps.templateLayoutFactory.createClass(
    `<div class="map-point">${buildPinSvg(FIGURE_PATH[type])}</div>`,
    {
      getShape(this: YMapsLayoutInstance): YMapsShape {
        return new ymaps.shape.Rectangle(
          new ymaps.geometry.pixel.Rectangle([
            POINT_ICON_OFFSET,
            [
              POINT_ICON_OFFSET[0] + POINT_ICON_SIZE[0],
              POINT_ICON_OFFSET[1] + POINT_ICON_SIZE[1],
            ],
          ]),
        );
      },
    },
  );

export const getPinIconShape = () => ({
  type: 'Rectangle' as const,
  coordinates: [
    POINT_ICON_OFFSET,
    [
      POINT_ICON_OFFSET[0] + POINT_ICON_SIZE[0],
      POINT_ICON_OFFSET[1] + POINT_ICON_SIZE[1],
    ],
  ],
});
